import { Component, Input } from '@angular/core';

enum TagEnum {
  'none',
  'success',
  'warning',
  'danger',
  'info',
}

const typeArray = ['', 'success', 'warning', 'danger', 'info'];
@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrl: './tag.component.scss',
})
export class TagComponent {
  @Input() customIcon: string;
  @Input() width: string;
  @Input() height: string;
  @Input() label: String | any;
  @Input() class: string;
  @Input() withIcon = true;
  @Input() type: any = TagEnum.none;

  constructor() {}

  get iconName(): string {
    return this.customIcon
      ? this.customIcon
      : typeArray[this.type];
  }

  protected readonly typeArray = typeArray;
}
